import React, { createContext, useContext, useRef, useState } from "react";
import DownloadManager, { DownloadManagerHandles, ZipJob } from "./DownloadManager";
import { useUser } from "../../context/UserContext";

interface DownloadContextProps {
  startDownload: (folderId: number, folderName: string) => void;
  jobs: ZipJob[];
}

const DownloadContext = createContext<DownloadContextProps | null>(null);

export const DownloadProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const managerRef = useRef<DownloadManagerHandles>(null);
  const [jobs] = useState<ZipJob[]>([]);
  const { userId } = useUser();
  return (
    <DownloadContext.Provider
      value={{
        startDownload: (folderId, folderName) => {
          managerRef.current?.startDownload(folderId, folderName);
        },
        jobs,
      }}
    >
      {children}
      <DownloadManager ref={managerRef} userId={userId} apiBase={process.env.REACT_APP_API_URL} />
    </DownloadContext.Provider>
  );
};

export const useDownload = () => {
  const ctx = useContext(DownloadContext);
  if (!ctx) throw new Error("useDownload must be used within DownloadProvider");
  return ctx;
};
